import { Alert, App, Button, Form, Input, Space, Typography } from 'antd'
import { useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { requestLoginMagicLink } from '../../utils/auth/requests'
import { emailRule, requiredRule } from '../../utils/rules'

const { Text } = Typography
const LoginPage = () => {
  const [form] = Form.useForm()
  const { message } = App.useApp()
  const [searchParams, _] = useSearchParams()

  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [error, setError] = useState<string | undefined>(undefined)

  const onSubmit = () => {
    setIsLoading(true)
    setError(undefined)
    requestLoginMagicLink(
      form.getFieldValue('email'),
      searchParams.get('returnTo')
    )
      .then(() => {
        message.success('Lien de connexion envoyé')
        form.resetFields()
      })
      .catch(() => {
        setError('Erreur')
      })
      .finally(() => setIsLoading(false))
  }

  return (
    <Space
      vertical
      className="w-full"
      style={{ textAlign: 'center' }}
      size={10}
    >
      <Space
        vertical
        className="w-full"
        style={{ textAlign: 'center' }}
        size={5}
      >
        <img
          src="/assets/linear_logo.png"
          style={{
            width: '100%',
            cursor: 'pointer',
          }}
        />
        <Text>
          {`Merci d'entrer votre email afin de recevoir un lien sécurisé pour
          accéder à votre espace.`}
        </Text>
      </Space>
      <Form layout="vertical" form={form} onFinish={onSubmit}>
        <Form.Item
          name="email"
          rules={[requiredRule(), emailRule()]}
          style={{ marginBottom: 10 }}
        >
          <Input placeholder={'Email'} autoComplete="email" />
        </Form.Item>
        <Button
          className="w-full"
          type="primary"
          htmlType="submit"
          loading={isLoading}
        >
          Recevoir mon lien de connexion
        </Button>
      </Form>
      {error && (
        <div style={{ textAlign: 'center', marginTop: 10 }}>
          <Alert style={{ marginBottom: 25 }} title={error} type="error" />
        </div>
      )}
    </Space>
  )
}

export default LoginPage
